module.exports = __webpack_public_path__ + "img/10.9aa70147.jpg";